// src/components/UnlabelledTransferRejectReasonModal.jsx
import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FiX } from "react-icons/fi";

const UnlabelledTransferRejectReasonModal = ({ open, bulk = false, onClose, onSubmit }) => {
  const [reason, setReason] = useState("");

  if (!open) return null;

  return (
    <AnimatePresence>
      <motion.div
        className="fixed inset-0 z-[9999] bg-black/40 flex items-center justify-center p-4"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onMouseDown={(e) => {
          if (e.target === e.currentTarget) onClose?.();
        }}
      >
        <motion.div
          className="w-full max-w-md bg-white rounded-2xl shadow-2xl border border-slate-200 overflow-hidden"
          initial={{ scale: 0.95, y: 18, opacity: 0 }}
          animate={{ scale: 1, y: 0, opacity: 1 }}
          exit={{ scale: 0.95, y: 18, opacity: 0 }}
        >
          <div className="px-4 py-3 bg-gradient-to-r from-[#ece9ff] to-[#f7f5ff] text-[#4b3d91] flex items-center justify-between border-b border-slate-200">
            <div className="leading-tight">
              <p className="font-semibold text-[13px]">
                {bulk ? "Reject selected items" : "Reject item"}
              </p>
              <p className="text-[11px] text-[#4b3d91]/70">
                Add a short reason (optional but recommended).
              </p>
            </div>

            <button
              type="button"
              onClick={onClose}
              className="inline-flex items-center justify-center h-9 w-9 rounded-2xl border border-slate-200 bg-white hover:bg-slate-50"
              title="Close"
            >
              <FiX />
            </button>
          </div>

          <div className="p-4">
            <label className="text-[11px] text-slate-600">Reason</label>
            <textarea
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="eg. Wrong item / Damaged / Not matching…"
              className="mt-1 w-full min-h-[90px] px-3 py-2 rounded-xl border border-slate-200 text-[12px] focus:outline-none focus:ring-1 focus:ring-violet-400"
            />
          </div>

          <div className="px-4 py-3 border-t border-slate-200 bg-slate-50 flex items-center justify-end gap-2">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-[12px] rounded-2xl border border-slate-200 bg-white hover:bg-slate-100"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={() => onSubmit?.(reason)}
              className="px-5 py-2 text-[12px] rounded-2xl bg-rose-500 text-white font-semibold hover:bg-rose-600"
            >
              Reject
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default UnlabelledTransferRejectReasonModal;
